import { PropsWithChildren } from 'react';
import Form from 'react-bootstrap/Form';
import { VisibilityIcon } from '../VisibilityIcon';
import { FormFieldVisibility } from './FormFieldVisibility';

export interface FormLabelProps {
  required?: boolean;
  srOnlyLabel?: boolean;
  visibility?: FormFieldVisibility;
  classNames?: string;
}

export const FormLabel = ({
  children,
  required,
  visibility,
  srOnlyLabel,
  classNames = 'fw-bold',
}: PropsWithChildren<FormLabelProps>) => (
  <Form.Label className={`text-field-label ${classNames} ${srOnlyLabel ? 'visually-hidden' : ''}`}>
    {children}
    {required ? <span className="text-danger"> *</span> : ''}
    <VisibilityIcon visibility={visibility} />
  </Form.Label>
);
